import { Message } from '@workwhile/ui'
import { useAuthContext } from 'components/auth'

export const CompanySwitchDetect = () => {
  const { companyChangedInAnotherTab } = useAuthContext()

  if (!companyChangedInAnotherTab) {
    return null
  }

  return (
    <Message
      variant="warning"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 10000,
        whiteSpace: 'normal',
        padding: '10px',
        boxSizing: 'border-box',
      }}
    >
      The company ID has changed in another tab. Please refresh this tab to
      reflect the changes.
    </Message>
  )
}
